import React from 'react'
import Lottie from "lottie-react";
import animationData from "../../utils/loading.json";
const InnerLoading = () => {
    return (
        <div className='  bg-white z-50 text-black flex-center h-full w-full flex-col gap-3'>
            <div style={{ width: 300, height: 300 }}>
                <Lottie animationData={animationData} loop={true} />
            </div>
        </div>
    )
}

export default InnerLoading